/**
 * QuadrantConfig Component
 * Configuration panel for editing quadrant title and color
 */
import React, { useState } from 'react';

export function QuadrantConfig({
  quadrant,
  presetColors,
  onUpdateTitle,
  onUpdateColor,
}) {
  const [titleInput, setTitleInput] = useState(quadrant.title);

  return (
    <div className="config-dropdown">
      <div className="config-section">
        <label className="config-label">Quadrant Title</label>
        <input
          type="text"
          value={titleInput}
          onChange={(e) => setTitleInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onUpdateTitle(titleInput);
            }
            if (e.key === 'Escape') {
              e.preventDefault();
              setTitleInput(quadrant.title);
              onUpdateTitle(quadrant.title); // This will trigger close
            }
          }}
          className="quadrant-title-input"
          placeholder="Enter title..."
          autoFocus
        />
      </div>
      <div className="config-section">
        <label className="config-label">Theme Color</label>
        <div className="color-options">
          {presetColors.map((c) => (
            <div
              key={c}
              className={`color-dot ${c} ${quadrant.color === c ? 'active' : ''}`}
              onClick={() => onUpdateColor(c)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
